/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} First_Connection_WaitingInputs */



/**
* | output |
* | --- |
* | "Awaiting first connection" |
*
* @param {First_Connection_WaitingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const first_connection_waiting = /** @type {((inputs?: First_Connection_WaitingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<First_Connection_WaitingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Awaiting first connection")
	return /** @type {LocalizedString} */ ("En attente de première connexion")
});